import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { Navigate } from 'react-router-dom';
import styles from './DataMigrationPage.module.css';

const DataMigrationPage: React.FC = () => {
  const { isAdmin, isLoggedIn } = useAuth();
  
  // Admin değilse ana sayfaya yönlendir
  if (!isLoggedIn || !isAdmin) {
    return <Navigate to="/" />;
  }
  
  return (
    <div className={styles.container}>
      <h1>Veri Aktarımı Araçları</h1>
      <p className={styles.description}>
        Bu sayfa, uygulama verilerini yerel dosyalardan Firebase veritabanına aktarmak için gerekli araçları içerir.
        Aktarım işlemleri dikkatli yapılmalı ve veri bütünlüğü kontrol edilmelidir.
      </p>
      
      
      <div className={styles.warningBox}>
        <h3>Önemli Uyarılar</h3>
        <ul>
          <li>Veri aktarımı öncesi veritabanı yedeği almanız önerilir.</li>
          <li>Aktarım sırasında aynı şehir koduna sahip kayıtlar atlanacaktır.</li>
          <li>Büyük veri miktarları için aktarım işlemi zaman alabilir.</li>
          <li>Aktarım işleminden sonra verileri Admin Paneli üzerinden kontrol ediniz.</li>
        </ul>
      </div>
    </div>
  );
};

export default DataMigrationPage;
